// extracted by mini-css-extract-plugin
module.exports = {"glacierBox":"box_glacierBox__YBJOC","waveTwoBox":"box_waveTwoBox__N25sB"};